module.exports = __webpack_public_path__ + "img/intelligent-bg2.3ca120b7.png";